// extracted by mini-css-extract-plugin
module.exports = {"carousel-container":"_1k5_n","arrow-left":"_2kFv5","image-element":"D9AA2"};